// Room Association Sidebar
// This tool associates an autocad entity (ehandle) with a room record in the Space Database
// This association in turn is used to join GIS features to the Space Database in nightly processing.

<template>
<div>
	<LeftSidebar :open="roomAssociationSidebarOpen" :width="650" :updateSidebar="updateRoomAssociationSidebar"
		:class="{ 'white' : !darkTheme, 'grey darken-2' : darkTheme }" 
		:lowerTitle="true"
		:dark=true	
		:loading = "drawingLoading"	
		:actionIcon="'help'"
        :actionFunction="showHelp"
        :actionTooltip="'About Association'"
		toolbarColor="deep-purple lighten-1"
		style="z-index: 31 !important"	>
		
		<div slot="sbTitle" >
			Room Association
    	</div> 

    	<div slot="sbContent">
    		<v-card class="mx-3 my-4 pb-4">
    			<v-toolbar color="deep-purple lighten-1" dark >			        
			    	<v-icon>image_aspect_ratio</v-icon>
			        <v-toolbar-title>Drawing</v-toolbar-title>
			        <v-spacer></v-spacer>
			        <v-toolbar-items>
			        	<v-layout row align-center>
			        		<v-layout column>
			        	<v-checkbox color="white" class="mr-4 pt-0"
				      		v-model="showCadText"
				      		label="Show CAD Text"
				      		hide-details>				      	
				      	</v-checkbox>
				      </v-layout>
				  </v-layout>
				      
				      </v-toolbar-items>

			    </v-toolbar>


	        	<v-container grid-list-md >
	        		<span v-if="room" class="pt-4">CAD Entity</span>
	    			<v-layout v-if="room" row wrap class="" >

			        	<v-flex class="">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.dwgName"
				    			readonly
				    			:style="`background-color: ${ehandleColor};`"
				            	label="Drawing">  
			            	</v-text-field>
		        		</v-flex> 
			        	<v-flex class="">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="room.ehandle"
				    			ref="ehandle"
				    			readonly
				    			:style="`background-color: ${ehandleColor};`"
				            	label="eHandle">  
			            	</v-text-field>	
			            	<v-tooltip top style="position: relative; top: -45px; left: 140px;">
								<v-btn small icon v-if="databaseRoom && room" light @click="associateRoom('ehandle'); changed=true" slot="activator">			           	
			        				<v-icon>file_download</v-icon>
			        			</v-btn>
								<span>Copy ehandle to database</span>
							</v-tooltip>
		            	
		        		</v-flex>
		        		<v-flex v-if="!room.roomKey" class="">
			    			<v-text-field class="body-1" hide-details box
				    			:value="(room.areaCAD).toLocaleString(undefined, { maximumFractionDigits: 0 })"
				    			:style="`background-color: ${ehandleColor};`"
				            	label="CAD Area">  
			            	</v-text-field>
			            	<v-tooltip top style="position: relative; top: -45px; left: 140px;">
								<v-btn small icon v-if="databaseRoom && room" light @click="associateRoom('area'); changed=true" slot="activator">			           	
			        				<v-icon>file_download</v-icon>
			        			</v-btn>
								<span>Copy area to database</span>
							</v-tooltip>
		        		</v-flex>
        			</v-layout>
        	  	</v-container>
        	</v-card>
	    	</v-card>
	    	<v-card class="mx-3 my-4 pb-4">


	    		<v-toolbar color="deep-purple lighten-1" dark >			        
			    	<v-icon>table_chart</v-icon>
			        <v-toolbar-title>Database</v-toolbar-title>
			        <v-spacer></v-spacer>			        

			        <!-- Function moved to individual ehandle and area fields above
			        	 Saved in case we want to go back to this combined function -->
			        <!-- <v-tooltip top>
						<v-btn v-if="databaseRoom && room" light @click="associateRoom(); changed=true" slot="activator">			           	
			        		<v-icon>transform</v-icon>
			        	</v-btn>
						<span>Associate: Copy ehandle and area</span>
					</v-tooltip> -->
					
					<v-btn v-show="!databaseRoom" light @click="createNewRoom(); setAutoMode(true)">			           	
			        	Auto Room
			        </v-btn>
			        <v-btn v-show="autoMode" light @click="setAutoMode(false); cancelRoomChanges()" color=orange>			           	
			        	Stop Auto Room
			        </v-btn>
			        

			        	
		           	
			    </v-toolbar>
			    <v-flex class="ml-4 mt-4">
			    	<span  v-if="!databaseRoom || databaseRoom && databaseRoom.roomKey">
			  			Search for a Room
			  		</span>
			    </v-flex>
			    
			    <v-layout v-if="!databaseRoom || databaseRoom && databaseRoom.roomKey" row class="mx-4 mb-4" style="height: 50px;" >
			    	
		  		
			    	<v-flex xs9>
			    		<v-autocomplete v-if=""
							ref="autocomplete"
							v-model="selectedBuilding"
							hide-no-data
							auto-select-first
							autocomplete
							box solo
							flat
							style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
							:items="buildingItems"
							label="Building Number"
							single-line
							@change="changed=false"
							>
							<template
						        slot="selection"
						        slot-scope="{ item, tile }"
						      >
						      	<v-layout v-if="selectedBuilding" v-on:click="selectedBuilding = null">
						        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
						        	{{item.bldgAlpha}}
						        </v-list-tile-avatar>
						        <v-list-tile-content>
						          <v-list-tile-title>
						          	{{item.name}}
						          </v-list-tile-title>
						          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
						        </v-list-tile-content>
						    	</v-layout>
						      </template>
							<template
						        slot="item"
						        slot-scope="{ item, tile }"
						      >
						        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
						        	{{item.bldgAlpha}}
						        </v-list-tile-avatar>
						        <v-list-tile-content>
						          <v-list-tile-title>
						          	{{item.name}}
						          </v-list-tile-title>
						          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
						        </v-list-tile-content>
						      </template>
						</v-autocomplete>
					</v-flex>
			

				  	<v-flex v-if="selectedBuilding" class="pl-3"> 
						<v-autocomplete
							ref="roomselect"					
							v-model="databaseRoom"
							item-text="number"
							item-value="number"
							autocomplete
							auto-select-first
							clearable
							box
							flat
							:items="buildingRooms"
							label="Room"
							:loading="loading"
							single-line
							hide-no-data
							return-object
							@change="changed=false">
							</v-autocomplete>
				  	</v-flex>
		  		</v-layout>

		  		<!-- Auto Numbering -->
		  		<span class="ml-4" v-if="databaseRoom && !databaseRoom.roomKey">
		  			<b>Auto Numbering</b>
		  		</span>
    			<v-layout v-if="databaseRoom && !databaseRoom.roomKey" row class="mx-4 mb-4">
		    		<v-flex xs2 class="mr-1">
		    			<v-text-field class="body-1 text-upper" hide-details box
			    			v-model="autoPrefix"
			    			label="prefix">  
		            	</v-text-field>
	        		</v-flex>
		        	<v-flex xs2 class="mr-1">
		    			<v-text-field class="body-1 text-upper" hide-details box
			    			v-model="autoMiddle"
			    			:rules="numberRules"
			    			label="Number"> 
		            	</v-text-field>
		        	</v-flex>
		        	<v-flex xs2 class="mr-2">
		    			<v-text-field class="body-1 text-upper" hide-details box
			    			v-model="autoSuffix"
			    			label="Suffix">  
		            	</v-text-field>
		        	</v-flex>
		        	<v-spacer></v-spacer><v-spacer></v-spacer>

<!-- 		        	<v-flex xs2 class="">
		    			<v-text-field class="body-1" hide-details box
			    			:value="autoNumber"
			    			readonly
			    			label="Next Number">  
		            	</v-text-field>
		        	</v-flex>
 		        	<v-flex>
		        	<v-btn large ><v-icon @click="incrementAuto">add</v-icon></v-btn>
		        	</v-flex> --> 
	        	</v-layout>
				
				
					<span v-if="databaseRoom" class="mx-4" ><b>Room Attributes</b></span>
		    		<v-layout  v-if="databaseRoom" row wrap justify-end class="mx-4 mt-2 mb-2" >		    			

			        	<!-- Room Edit Grid -->

	    				<v-flex xs3 class="">
			    			<v-autocomplete class="body-1" hide-details box
			    				:items="buildingItems"
				    			v-model="databaseRoom.bldgAlpha"
				    			@input="changed=true"
				            	label="BldgAlpha">  
			            	</v-autocomplete>
			        	</v-flex>

			        	<v-flex xs2 >
			    			<v-text-field class="body-1" hide-details box
				    			v-model="databaseRoom.number" 
				    			@input="changed=true"
				            	label="Number">  
			            	</v-text-field>
			        	</v-flex>

			        	<v-flex xs2 class="">
			    			<v-text-field class="body-1" hide-details box
				    			v-model="databaseRoom.floor"
				    			@input="changed=true"
				            	label="Floor">  
			            	</v-text-field>
			        	</v-flex>

			        	<v-flex xs3>
			    			<v-text-field class="body-1" hide-details box
				    			v-model="databaseRoom.dwgName"
				    			@input="changed=true"
				    			:style="`background-color: ${ehandleColor}; transition: background 0.5s ease-in-out;`"
				            	label="Drawing">  
			            	</v-text-field>
		        		</v-flex> 

		        		<v-flex xs2 >
			    			<v-text-field class="body-1" hide-details box
				    			v-model="databaseRoom.ehandle"
				    			ref="ehandle"
				    			@input="changed=true"
				    			:style="`background-color: ${ehandleColor}; transition: background 0.5s ease-in-out;`"
				            	label="eHandle">  
			            	</v-text-field>
		        		</v-flex>

		        		<v-flex xs2 >
			    			<v-text-field class="body-1" hide-details box
				    			v-model="databaseRoom.areaManual"
				    			ref=""
				    			@input="changed=true"
				    			:style="`background-color: ${ehandleColor}; transition: background 0.5s ease-in-out;`"
				            	label="Manual Area">  
			            	</v-text-field>
		        		</v-flex>

		        		<v-flex xs2 >
			    			<v-text-field class="body-1" hide-details box
				    			v-model="databaseRoom.areaCAD"
				    			ref=""
				    			@input="changed=true"
				    			:style="`background-color: ${ehandleColor}; transition: background 0.5s ease-in-out;`"
				            	label="CAD Area">  
			            	</v-text-field>
		        		</v-flex>		        		
			        	
					 </v-layout>

			    <v-layout v-if="changed && databaseRoom && databaseRoom.roomKey" class="mt-3 mr-4 pr-3">
		        	<v-flex xs6 class="mr-4">
		        		<v-btn block @click="updateRoom" class="ml-3 mr-4" color="light-green lighten-3 ">Save</v-btn>
		        	</v-flex>
		        	<v-flex xs6>
		        		<v-btn block @click="cancelRoomChanges" class="ml-3 mr-4" color="light-green lighten-3 ">Cancel</v-btn>
		        	</v-flex>
		        </v-layout>   		
	    	</v-card>


    	</div>	    
	</LeftSidebar>
	<HelpRoomAssociation />
</div>
</template>

<script>

import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import LeftSidebar from './LeftSidebar'
import DrawingUpload from '@/components/forms/DrawingUpload.vue'
import HelpRoomAssociation from '@/components/help/HelpRoomAssociation'

  	let RoomAssociationSidebar = {

		data() {
	  		return {
	  			expansionPanel: [],
	  			dbBuilding : null, 
	  			showText: true,
	  			dwgName: null,
	  			ehandleColor: "#D1C4E9",
	  			changed: false,
		        newRoom: {  
		        		bldgAlpha : this.spaceBuilding ? this.spaceBuilding.bldgAlpha : null,
		            /*  floor: '1', 
		                number: null,
		                dwgName: null,
		                ehandle: null,
		                areaManual: null, 
		                dateInventory: null, 
		                capacity: null, 
		                type: null, 
		                use: null, 
		                classification: null, 
		                comment: null, */
		          		},

		        numberRules: [
							        v => !!v && !isNaN(v) || 'Must be number.',
						       ],
	  		}
		},

		components : { LeftSidebar, DrawingUpload, HelpRoomAssociation },

		watch: { 
			roomAssociationSidebarOpen (val) {
				//if (val) { this.$refs.focus.focus() }
				if (!val) { this.setAutoMode(false); this.cancelRoomChanges(); }
			}
		},

		computed: {

			...mapState({
				mainSidebarOpen: state => state.ui.mainSidebarOpen,
				roomAssociationSidebarOpen: state => state.ui.roomAssociationSidebarOpen,
				darkTheme: state => state.ui.darkTheme,
				isSuperUser: state => state.user.isSuperUser,
				room: state => state.association.room,   				// This is the clicked graphic
				databaseRoom: state => state.association.databaseRoom,	// This is a room object - Space Database
				buildingRooms: state => state.space.buildingRooms,
				currentFloor: state => state.ui.currentFloor,
				autoMode: state => state.association.autoMode,
				spaceBuilding: state => state.space.selectedBuilding,
				drawingLoading: state => state.association.drawingLoading,
				map: state => state.mapFunctions.stateMap,
			}),
			...mapGetters(['getRoom', ]),

			showCadText: {
				get () {
					return this.$store.state.ui.showCadText
				},
				set (value) {
					if (!value) { this.map.getLayer('cadtextlayer').hide() }
						else { this.map.getLayer('cadtextlayer').show() }
					this.updateShowCadText(value) // Not really necessary, but it was left over.

				}
			},

			databaseRoom: {
				get() {
					if (this.$store.state.association.databaseRoom && this.spaceBuilding && this.spaceBuilding.bldgAlpha) { 
						this.$store.state.association.databaseRoom.bldgAlpha = this.spaceBuilding.bldgAlpha 
					}
					return this.$store.state.association.databaseRoom
				},
				set (value) {
					this.setDatabaseRoom(value)
				}
			},

			autoPrefix: {
				get () {
					return this.$store.state.association.autoPrefix
				},
				set (value) {
					this.setAutoPrefix(value.toUpperCase())
				}
			},

			autoMiddle: {
				get () {
					return this.$store.state.association.autoMiddle
				},
				set (value) {
					this.setAutoMiddle(value)
				}
			},

			autoSuffix: {
				get () {
					return this.$store.state.association.autoSuffix
				},
				set (value) {
					this.setAutoSuffix(value.toUpperCase())
				}
			},

			autoNumber: function () {
				let retVal = ""
				if (isNaN(this.autoMiddle)) { return }
				retVal += this.autoPrefix || ""
				retVal += this.autoMiddle
				retVal += this.autoSuffix || ""
				return retVal
			},

			buildingItems : function () {
			  const items = []
			  this.$store.state.space.buildings.forEach(bldg => {
				bldg.text = `${bldg.bldgAlpha} - ${bldg.name}`
				bldg.value = bldg.bldgAlpha
				items.push(bldg)
			  })
			  return items
			},


			loading: function () {
				return this.buildingRooms && this.buildingRooms.length > 0 ? false : true
			},

			selectedBuilding : {
			    get () {
			    	return this.spaceBuilding
			    },

			    set (value) {	
			    	//this.dbBuilding = value
			    	this.selectBuilding(value)
			    	
			    }
			},
		},

		methods: {
		  	...mapMutations([	'updateContentSidebar', 
		  						'updateRoomAssociationSidebar',
		  						'setSnackText', 'updateShowCadText',
		  						'setAutoPrefix', 'setAutoMiddle', 'setAutoSuffix',
		  						'incrementAuto', 'setDatabaseRoom', 'setAutoMode', 'setShowHelpRoomAssociation'
	  						]),

		  	...mapActions([ 'addNullFeatures', 'mapCenterOnDrawing', 'fetchBuildingRooms', 'selectBuilding', 'setAssociationRoom', 
		  					'associateRoom', 'saveRoom', 'symbolizeNullFeatureLayer', 'updateLayerVisibility']),

		  	gotoDrawing: function() {
		  		console.log("Go To Drawing")
	  			let docName = this.dwgName.split(".")[0]+".dwg"
	  			this.addNullFeatures({'floor': this.currentFloor, 'docName': docName})
	  		},

	  		updateRoom: function() {
	  			this.changed=false
	  			this.setSnackText('Saved')
	  			this.saveRoom(this.databaseRoom).then(() => { 
	  				this.symbolizeNullFeatureLayer(this.spaceBuilding.bldgAlpha) 
	  				this.setDatabaseRoom(null)
	  			})

	  			// Costly
	  			//this.fetchBuildingRooms(this.dbBuilding)
	  			
	  		},

	  		showHelp: function () {
	  			console.log("Show Help")
        		this.setShowHelpRoomAssociation(true)
    		},

/*	  		associateRoom: function () {

	  			if (this.databaseRoom && this.room ) {
	  				this.changed=true
		  			this.databaseRoom.ehandle = this.room.ehandle
		  			this.databaseRoom.dwgName = this.room.dwgName.split(".")[0]
					this.ehandleColor = "#9575CD"
					setTimeout( () => {
		               this.ehandleColor = "#D1C4E9"
		            }, 500);
				}
			},*/

/*			incrementAuto: function () {
				this.autoMiddle = parseInt(this.autoMiddle) + 1
			},*/

			createNewRoom : function () {
				console.log("Create New Room")
				this.setAssociationRoom(null)
				this.databaseRoom = { ...this.newRoom}
				this.databaseRoom.floor = this.currentFloor
				this.changed=true
			},

			cancelRoomChanges: function () {
				this.databaseRoom = null
				this.changed=false
			},

			
			
		}						
	}
export default RoomAssociationSidebar
</script>


<style>

</style>





// WEBPACK FOOTER //
// src/components/RoomAssociationSidebar.vue